import React from 'react'
import {
    Create,
    TextInput,
    BooleanInput,
    SimpleForm,
    number,
}
    from 'react-admin'

import ShopRevenueCenterTitle from './ShopRevenueCenterTitle';
import { NameAutocompleteInput } from '../customInputs';

export default function ShopRevenueCenterCreate(props) {
    return (
        <Create title={<ShopRevenueCenterTitle />} {...props}>
            <SimpleForm>
                <TextInput source="index" validate={number()} />
                <TextInput source="name" />
                <NameAutocompleteInput source='shopId' reference="shop" />
                <NameAutocompleteInput source='revenueCenterId' reference="revenueCenter" />
                <BooleanInput source="active" />
            </SimpleForm>
        </Create>
    )
}
